import React from "react";
import logo from "../../assets/logo.png";
import SurveyList from "./SurveyList/SurveyList";
import { Layout, Row, Col, Select, Button } from "antd";
import { Link } from "react-router-dom";

const { Header } = Layout;

const Option = Select.Option;

function FrontPage(props) {
  props.changeStep("ANALYSIS");

  const { id } = props.match.params;
  const isAdmin =
    props.location.state &&
    props.location.state.isAdmin &&
    props.location.state.isAdmin
      ? props.location.state.isAdmin
      : false;

  return (
    <Layout
      style={{ height: "-webkit-fill-available", backgroundColor: "black" }}
    >
      <Header style={{ minHeight: "200px", backgroundColor: "black" }}>
        <Row>
          <Col md={12} offset={6}>
            <div className="logo">
              <Link to="/">
                <img alt='front-page' src={logo} height="70px" />
              </Link>
            </div>
          </Col>
        </Row>
        <div className="header_navigation_language">
          <Select
            labelInValue
            defaultValue={{ key: props.language }}
            value={{ key: props.language }}
            style={{ width: 120 }}
            onChange={({ key }) => props.changeLanguage(key)}
          >
            <Option value="dk">Dansk</Option>
            <Option value="en">English</Option>
          </Select>
        </div>
        <h3 style={{ color: "white", marginTop: "50px" }}>
          {props.language ==="en"
            ? "Welcome " + props.user.email
            : "Velkommen " + props.user.email}
        </h3>
      </Header>

      <div>
        <SurveyList
          surveys={props.surveys.filter(survey => survey.userId === id)}
          hasFilledTa={props.user.hasFilledTa}
          hasFilled24={props.user.hasFilled24}
          hasFilled12={props.user.hasFilled12}
          isTa={
            props.location.state &&
            props.location.state.isTa &&
            props.location.state.isTa
              ? props.location.state.isTa
              : false
          }
          language={props.language}
        />
      </div>

      <Row>
        <Col>
          <div style={{ backgroundColor: "black" }}>
            {isAdmin ? (
              <Button href={"/admin/blog"}>Gå til admin side</Button>
            ) : null}
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default FrontPage;



// WEBPACK FOOTER //
// ./src/pages/FrontPage/index.js